// extracted by mini-css-extract-plugin
export default {"richTextViewer":"RichTextViewer-module__richTextViewer--r3NnR"};